import script from "./KBaseResultsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./KBaseResultsTable.vue?vue&type=script&setup=true&lang=js"

import "./KBaseResultsTable.vue?vue&type=style&index=0&id=495f382d&lang=scss&scoped=true"

import exportComponent from "F:\\APG\\LatestProject\\vue-search-filters\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-495f382d"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QCard,QCardSection,QImg,QChip,QBtn});
